var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('ClTableSimple',{attrs:{"headers":_vm.table.headers,"items":_vm.tableItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }